import { render, staticRenderFns } from "./Actividades.vue?vue&type=template&id=7f129578&scoped=true"
import script from "./Actividades.vue?vue&type=script&lang=js"
export * from "./Actividades.vue?vue&type=script&lang=js"
import style0 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Actividades.vue?vue&type=style&index=2&id=7f129578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f129578",
  null
  
)

export default component.exports